import { render } from "./WalletsList.vue?vue&type=template&id=5e304cf3"
import script from "./WalletsList.vue?vue&type=script&lang=js"
export * from "./WalletsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__